import React, { useState } from "react";
import { BiEnvelope } from "react-icons/bi";
import {
  FaBell,
  FaCalendarAlt,
  FaExclamationCircle,
  FaPlus,
} from "react-icons/fa";

export default function AutomatisationsPage() {
  const [activeTab, setActiveTab] = useState("tout");

  const tabs = [
    { id: "tout", label: "Tout" },
    { id: "rappels", label: "Rappels" },
    { id: "notifications", label: "Notifications de rendez-vous" },
    // { id: "mises-a-jour", label: "Mises à jour de la liste d'atta..." },
    // { id: "augmenter", label: "Augmenter les réservations" },
    // { id: "celebrer", label: "Célébrer les étapes importa..." },
  ];

  const rappels = [
    {
      id: 1,
      title: "Rappel de rendez-vous à venir dans 24 heures",
      description: "Notifie les clients de leurs rendez-vous à venir.",
      active: true,
    },
    {
      id: 2,
      title: "Rappel de rendez-vous à venir dans 1 heure",
      description: "Notifie les clients de leurs rendez-vous à venir.",
      active: true,
    },
  ];

  const notifications = [
    {
      id: 1,
      icon: <FaCalendarAlt className="w-6 h-6" />,
      title: "Nouveau rendez-vous",
      description: "Contactez les clients lorsque leur rendez-vous a été pris.",
      active: true,
    },
    {
      id: 2,
      icon: <FaCalendarAlt className="w-6 h-6" />,
      title: "Rendez-vous reprogrammé",
      description:
        "Automatiquement envoyé aux clients lorsque l'heure de leur rendez-vous est modifiée.",
      active: true,
    },
    {
      id: 3,
      icon: <FaCalendarAlt className="w-6 h-6" />,
      title: "Rendez-vous annulé",
      description:
        "Automatiquement envoyé aux clients lorsque leur rendez-vous est annulé.",
      active: true,
    },
    {
      id: 4,
      icon: <FaExclamationCircle className="w-6 h-6" />,
      title: "Rendez-vous manqué",
      description:
        "Automatiquement envoyé aux clients quand leur rendez-vous est manqué comme rendez-vous manqué.",
      active: true,
    },
  ];

  return (
    <div className="w-full min-h-screen bg-white p-8">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-black mb-2">
            Automatisations
          </h1>
          <p className="text-gray-600">
            Consultez et gérez tous les messages automatiques envoyés à vos
            clients.
            {/* <a href="#" className="text-secondary hover:underline">
              En savoir plus
            </a> */}
          </p>
        </div>

        {/* Tabs */}
        <div className="flex gap-3 mb-8 overflow-x-auto pb-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 font-medium whitespace-nowrap transition-colors ${
                activeTab === tab.id
                  ? "bg-black text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        {activeTab === "rappels" && (
          <div>
            <h2 className="text-2xl font-bold text-black mb-6">Rappels</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {rappels.map((rappel) => (
                <div key={rappel.id} className="border border-gray-200 p-6">
                  <div className="flex justify- mb-4">
                    <FaBell className="w-5 h-5 text-secondary mt-1" />
                  </div>
                  <div className="flex items-start gap-3 mb-3">
                    <h3 className="font-semibold text-black">{rappel.title}</h3>
                  </div>
                  <p className="text-sm text-gray-600 mb-4">
                    {rappel.description}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="text-green-600 text-sm font-medium">
                      Actif
                    </span>
                    <button className="ml-auto text-gray-400 hover:text-gray-600">
                      <BiEnvelope />
                    </button>
                  </div>
                </div>
              ))}
              <div className="border border-dashed border-gray-300 p-6 flex items-center justify-center">
                <button className="flex flex-col items-center gap-2 text-secondary hover:text-secondary/80">
                  <FaPlus className="w-6 h-6" />
                  <span className="text-sm font-medium">Nouveau</span>
                </button>
              </div>
            </div>
          </div>
        )}

        {activeTab === "notifications" && (
          <div>
            <h2 className="text-2xl font-bold text-black mb-6">
              Notifications de rendez-vous
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {notifications.map((notif) => (
                <div key={notif.id} className="border border-gray-200 p-6">
                  <div className="flex justify- mb-4">
                    <div className="text-secondary">{notif.icon}</div>
                  </div>
                  <h3 className="font-semibold text-black  mb-2">
                    {notif.title}
                  </h3>
                  <p className="text-sm text-gray-600 text- mb-4">
                    {notif.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-green-600 text-sm font-medium">
                      Actif
                    </span>
                    <button className="text-gray-400 hover:text-gray-600">
                      <BiEnvelope />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "mises-a-jour" && (
          <div className="text-center py-12">
            <p className="text-gray-500">Contenu à venir</p>
          </div>
        )}

        {activeTab === "augmenter" && (
          <div className="text-center py-12">
            <p className="text-gray-500">Contenu à venir</p>
          </div>
        )}

        {activeTab === "celebrer" && (
          <div className="text-center py-12">
            <p className="text-gray-500">Contenu à venir</p>
          </div>
        )}

        {activeTab === "tout" && (
          <div>
            <h2 className="text-2xl font-bold text-black mb-6">Rappels</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
              {rappels.map((rappel) => (
                <div key={rappel.id} className="border border-gray-200 p-6">
                  <div className="flex justify- mb-4">
                    <FaBell className="w-5 h-5 text-secondary mt-1" />
                  </div>
                  <div className="flex items-start gap-3 mb-3">
                    <h3 className="font-semibold text-black">{rappel.title}</h3>
                  </div>
                  <p className="text-sm text-gray-600 mb-4">
                    {rappel.description}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="text-green-600 text-sm font-medium">
                      Actif
                    </span>
                    <button className="ml-auto text-gray-400 hover:text-gray-600">
                      <BiEnvelope />
                    </button>
                  </div>
                </div>
              ))}
              <div className="border border-dashed border-gray-300 p-6 flex items-center justify-center cursor-pointer ">
                <button className="flex flex-col items-center gap-2 text-secondary hover:text-secondary/80">
                  <FaPlus className="w-6 h-6" />
                  <span className="text-sm font-medium">Nouveau</span>
                </button>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-black mb-6">
              Notifications de rendez-vous
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {notifications.map((notif) => (
                <div key={notif.id} className="border border-gray-200 p-6">
                  <div className="flex justify-c enter mb-4">
                    <div className="text-secondary">{notif.icon}</div>
                  </div>
                  <h3 className="font-semibold text-black text-cen ter mb-2">
                    {notif.title}
                  </h3>
                  <p className="text-sm text-gray-600 text-ce nter mb-4">
                    {notif.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-green-600 text-sm font-medium">
                      Actif
                    </span>
                    <button className="text-gray-400 hover:text-gray-600">
                      <BiEnvelope />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
